import { render, staticRenderFns } from "./CountryCard.vue?vue&type=template&id=dd18e41a&scoped=true&"
import script from "./CountryCard.vue?vue&type=script&lang=js&"
export * from "./CountryCard.vue?vue&type=script&lang=js&"
import style0 from "./CountryCard.vue?vue&type=style&index=0&id=dd18e41a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd18e41a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardSubtitle,VCardText,VImg})
